export interface Work {
  id: string;
  title: string;
  type: '电影' | '电视剧' | '短片';
  year: number;
  role: string;
  roleType: '主演' | '配角' | '特别出演';
  director: string;
  runtime: string;
  rating: number;
  tags: string[];
  cover: string;
  summary: string;
  story: string;
}

export const works: Work[] = [
  {
    id: 'against-the-light',
    title: '逆光之夏',
    type: '电影',
    year: 2019,
    role: '佐仓绫',
    roleType: '主演',
    director: '森田和彦',
    runtime: '118分钟',
    rating: 8.6,
    tags: ['剧情', '治愈', '海边小镇'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20tones%20with%20a%20warm%20amber%20sunbeam%2C%20silhouette%20walking%20along%20a%20seaside%20road%20at%20sunset%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20texture%20and%20elegant%20editorial%20style&width=600&height=900&seq=work-01&orientation=portrait',
    summary: '盛夏海边小镇，一段关于告别与重逢的温柔叙事。',
    story:
      '佐仓绫在离开故乡七年后重返海边小镇，处理祖母留下的旧旅馆。推开那扇斑驳的木门，她遇见了当年不告而别的旧友，也遇见了被时间掩埋的自己。海风、蝉鸣与褪色的照片，构成一段关于和解与成长的夏日记忆。',
  },
  {
    id: 'deep-sea-echo',
    title: '深海回声',
    type: '电影',
    year: 2020,
    role: '研究员南云',
    roleType: '主演',
    director: '中村凉介',
    runtime: '126分钟',
    rating: 8.9,
    tags: ['悬疑', '科幻', '深海'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20with%20deep%20navy%20blue%20and%20charcoal%20gradients%2C%20abstract%20ocean%20depth%20and%20glowing%20particles%2C%20a%20lone%20figure%20in%20a%20research%20suit%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20elegant%20editorial%20style&width=600&height=900&seq=work-02&orientation=portrait',
    summary: '一艘深海科考船收到来自三千米海底的不明信号。',
    story:
      '深海研究员南云随科考船潜入马里亚纳海沟，追寻一段不断重复的神秘声波。随着下潜深度增加，团队的理性逐渐被未知吞没。影片以冷峻的影像语言，探讨人类在浩瀚深海面前的渺小与执念。',
  },
  {
    id: 'midnight-train',
    title: '午夜列车',
    type: '电影',
    year: 2018,
    role: '列车员绘里',
    roleType: '主演',
    director: '石井健太',
    runtime: '112分钟',
    rating: 8.2,
    tags: ['悬疑', '都市', '夜行'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20train%20window%20lights%2C%20midnight%20railway%20platform%20with%20rain%2C%20silhouette%20of%20a%20woman%20in%20uniform%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-03&orientation=portrait',
    summary: '末班列车上的六名乘客，各自藏着不可言说的秘密。',
    story:
      '末班列车驶离站台后不再停靠，列车员绘里发现乘客名单上多出一个本不该存在的名字。随着车厢灯光一次次熄灭，六个人的过去被逐一揭开。影片用紧凑的封闭空间叙事，直指人性的幽微之处。',
  },
  {
    id: 'tokyo-new-chapter',
    title: '东京物语·新篇',
    type: '电视剧',
    year: 2021,
    role: '长女由美',
    roleType: '主演',
    director: '小泉真一',
    runtime: '全10集',
    rating: 8.4,
    tags: ['家庭', '都市', '群像'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20drama%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20grey%20with%20warm%20amber%20window%20glow%2C%20modern%20Tokyo%20cityscape%20at%20dusk%20with%20a%20family%20silhouette%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20series%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-04&orientation=portrait',
    summary: '一个普通东京家庭三代人，在时代变迁中的聚散离合。',
    story:
      '长女由美在父亲退休后接下家族小店的经营，妹妹远赴海外，弟弟困于理想与现实之间。十集篇幅里，这个家庭经历拆迁、疾病与和解。剧集以细腻克制的笔触，描绘当代都市家庭的真实温度。',
  },
  {
    id: 'confession-in-rain',
    title: '雨中的告白',
    type: '电影',
    year: 2017,
    role: '咖啡店老板小夜',
    roleType: '主演',
    director: '森田和彦',
    runtime: '104分钟',
    rating: 7.9,
    tags: ['爱情', '文艺', '雨天'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romance%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20umbrella%20light%2C%20rainy%20city%20street%20at%20night%20with%20soft%20reflections%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20elegant%20editorial%20style&width=600&height=900&seq=work-05&orientation=portrait',
    summary: '一场持续整月的雨，见证两个人的靠近与错过。',
    story:
      '咖啡店老板小夜习惯在每个雨天为一位总是迟到的客人留一盏灯。雨季漫长，两人在沉默中交换着各自的故事，却始终没有说出那句告白。影片用雨的意象贯穿始终，温柔而克制。',
  },
  {
    id: 'distant-stars',
    title: '遥远的星空',
    type: '电影',
    year: 2022,
    role: '天文学者凛',
    roleType: '主演',
    director: '中村凉介',
    runtime: '131分钟',
    rating: 9.1,
    tags: ['剧情', '科幻', '天文'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20a%20warm%20amber%20starlight%20horizon%2C%20observatory%20dome%20under%20a%20vast%20starfield%2C%20silhouette%20of%20a%20woman%20scientist%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-06&orientation=portrait',
    summary: '在山顶天文台，她寻找一颗只存在于论文中的星。',
    story:
      '天文学者凛在偏远的山顶天文台守护着一台老旧望远镜，执着地搜寻一颗可能并不存在的恒星。当观测数据终于出现异常，她却必须在学术声誉与真实之间做出选择。影片探讨科学、孤独与信念。',
  },
  {
    id: 'white-notes',
    title: '白色记事簿',
    type: '电视剧',
    year: 2020,
    role: '急诊医生千夏',
    roleType: '主演',
    director: '小泉真一',
    runtime: '全12集',
    rating: 8.7,
    tags: ['医疗', '行业', '群像'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20medical%20drama%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20corridor%20light%2C%20hospital%20hallway%20at%20night%20with%20a%20doctor%20silhouette%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20series%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-07&orientation=portrait',
    summary: '急诊科走廊里的每一次奔跑，都是与时间的争夺。',
    story:
      '急诊医生千夏在高压的夜班里，要面对的不只是病患，还有制度的局限与人心的疲惫。十二集故事围绕一个个真实感强烈的病例展开，也记录了一位年轻医生从理想走向成熟的过程。',
  },
  {
    id: 'spring-cherry',
    title: '春樱',
    type: '短片',
    year: 2016,
    role: '归乡少女',
    roleType: '主演',
    director: '石井健太',
    runtime: '32分钟',
    rating: 7.6,
    tags: ['文艺', '短片', '故乡'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20cherry%20blossom%20light%2C%20quiet%20Japanese%20lane%20lined%20with%20sakura%20trees%2C%20silhouette%20of%20a%20young%20woman%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-08&orientation=portrait',
    summary: '樱花树下，一个少女决定留下的瞬间。',
    story:
      '在外打拼多年的少女回到乡下，只为参加外婆的葬礼。短短数日里，她在樱花树下重新认识了自己出生的地方。短片用极简的叙事与画面，讲述关于「归处」的温柔叩问。',
  },
  {
    id: 'silent-proof',
    title: '沉默的证明',
    type: '电视剧',
    year: 2023,
    role: '检察官美咲',
    roleType: '主演',
    director: '中村凉介',
    runtime: '全10集',
    rating: 8.8,
    tags: ['悬疑', '律政', '犯罪'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20legal%20thriller%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20lamp%20light%2C%20dim%20interrogation%20room%20with%20a%20prosecutor%20silhouette%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20series%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-09&orientation=portrait',
    summary: '当所有证词都指向同一人，真相却藏在沉默里。',
    story:
      '检察官美咲接手一桩看似脉络清晰的旧案重审，却在一份被忽略的物证中发现了裂缝。随着调查深入，她逐渐意识到，最有力的证明往往来自那些不愿开口的人。剧集以扎实的推理铺陈现实议题。',
  },
  {
    id: 'shape-of-wind',
    title: '风的形状',
    type: '短片',
    year: 2015,
    role: '风筝匠人之女',
    roleType: '主演',
    director: '森田和彦',
    runtime: '28分钟',
    rating: 7.4,
    tags: ['文艺', '短片', '成长'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20sky%20glow%2C%20kite%20soaring%20over%20a%20grassy%20hill%20at%20golden%20hour%2C%20silhouette%20of%20a%20young%20woman%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-10&orientation=portrait',
    summary: '手艺人的女儿，用风筝丈量自己与父亲的距离。',
    story:
      '风筝匠人之女从小看着父亲把竹篾削成会飞的形状，却始终觉得难以靠近沉默的父亲。一场风筝比赛让她第一次读懂了那份笨拙的爱。短片轻盈而动人，是关于理解与传承的小品。',
  },
  {
    id: 'key-of-memory',
    title: '记忆之匙',
    type: '电影',
    year: 2019,
    role: '心理咨询师纱织',
    roleType: '主演',
    director: '石井健太',
    runtime: '122分钟',
    rating: 8.5,
    tags: ['悬疑', '心理', '记忆'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20psychological%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20glow%2C%20abstract%20fragmented%20mirror%20reflection%20of%20a%20woman%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20elegant%20editorial%20style&width=600&height=900&seq=work-11&orientation=portrait',
    summary: '一位心理咨询师，试图拼凑自己断裂的童年记忆。',
    story:
      '心理咨询师纱织擅长帮别人整理记忆，却始终无法面对自己七岁那年的空白。当一位特殊来访者带来线索，她不得不重新审视那些被刻意遗忘的片段。影片在悬疑外壳下探讨记忆与自我。',
  },
  {
    id: 'her-in-the-night',
    title: '夜幕下的她',
    type: '电影',
    year: 2021,
    role: '记者沙罗',
    roleType: '主演',
    director: '小泉真一',
    runtime: '115分钟',
    rating: 8.3,
    tags: ['悬疑', '都市', '调查'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20thriller%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20street%20lamp%20light%2C%20neon-lit%20city%20alley%20at%20night%2C%20silhouette%20of%20a%20woman%20journalist%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-12&orientation=portrait',
    summary: '一名记者的调查，揭开城市夜晚隐藏的另一面。',
    story:
      '记者沙罗为追踪一则匿名线索，走进城市深夜的另一面。她记录下被白昼遮蔽的故事，也渐渐发现自己正被某种力量注视。影片节奏紧凑，影像风格冷峻而锋利。',
  },
  {
    id: 'the-way-home',
    title: '归途',
    type: '短片',
    year: 2018,
    role: '返乡母亲',
    roleType: '主演',
    director: '中村凉介',
    runtime: '26分钟',
    rating: 7.7,
    tags: ['文艺', '短片', '亲情'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20dusk%20light%2C%20long%20country%20road%20at%20twilight%20with%20a%20lone%20traveler%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-13&orientation=portrait',
    summary: '一条回家的路，走了十年才重新走完。',
    story:
      '阔别家乡十年的母亲终于启程回乡，沿途的风景与记忆交叠。当车窗外的稻田渐渐熟悉，她才明白，归途的意义不在于抵达，而在于重新学会告别。短片真挚克制，余韵悠长。',
  },
  {
    id: 'city-lights',
    title: '城市之光',
    type: '电视剧',
    year: 2022,
    role: '建筑设计师结衣',
    roleType: '主演',
    director: '石井健太',
    runtime: '全8集',
    rating: 8.1,
    tags: ['都市', '职场', '群像'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20urban%20drama%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20skyline%20lights%2C%20city%20skyline%20at%20dusk%20with%20construction%20cranes%2C%20silhouette%20of%20a%20woman%20architect%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20series%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-14&orientation=portrait',
    summary: '一座不断生长的城市，和一群建造它的人。',
    story:
      '建筑设计师结衣参与老城区改造项目，在现代与记忆之间反复权衡。八集故事通过一群城市建设者的视角，记录一座城市的更新，也记录他们的理想、妥协与坚持。',
  },
  {
    id: 'the-seventh-letter',
    title: '第七封信',
    type: '电影',
    year: 2020,
    role: '图书编辑奈月',
    roleType: '主演',
    director: '森田和彦',
    runtime: '119分钟',
    rating: 8.6,
    tags: ['爱情', '悬疑', '书信'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20romantic%20mystery%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20desk%20lamp%20light%2C%20scattered%20handwritten%20letters%20on%20a%20wooden%20desk%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20elegant%20editorial%20style&width=600&height=900&seq=work-15&orientation=portrait',
    summary: '七封未寄出的信，牵出一段跨越二十年的约定。',
    story:
      '图书编辑奈月在整理旧稿时，发现了一叠从未寄出的信。顺着字迹，她找到了写信人，也走进了一段跨越二十年的沉默约定。影片以书信为线索，讲述时间如何温柔地改变一切。',
  },
  {
    id: 'seaside-inn',
    title: '海边旅店',
    type: '电影',
    year: 2017,
    role: '旅店主人千寻',
    roleType: '主演',
    director: '小泉真一',
    runtime: '108分钟',
    rating: 7.8,
    tags: ['剧情', '治愈', '海边'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20slice%20of%20life%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20lantern%20light%2C%20small%20seaside%20inn%20by%20the%20shore%20at%20dusk%2C%20silhouette%20of%20a%20woman%20innkeeper%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-16&orientation=portrait',
    summary: '一间海边旅店，收留了所有走累的人。',
    story:
      '旅店主人千寻习惯了迎来送往，她记得每位客人的口味，却很少有人记得她。直到一个漫长的淡季，几位停留的旅人用各自的方式，让这间安静的旅店重新有了温度。影片舒缓而治愈。',
  },
  {
    id: 'wrinkles-of-time',
    title: '时间的皱褶',
    type: '电影',
    year: 2023,
    role: '钟表修复师澄',
    roleType: '主演',
    director: '中村凉介',
    runtime: '128分钟',
    rating: 8.9,
    tags: ['剧情', '科幻', '时间'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20mechanical%20glow%2C%20intricate%20clockwork%20gears%20and%20a%20watchmaker%20bench%2C%20silhouette%20of%20a%20woman%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-17&orientation=portrait',
    summary: '钟表修复师发现，有些表走的是另一种时间。',
    story:
      '钟表修复师澄收到一只无法用常规原理解释的旧怀表。随着修复的深入，她发现每校准一次，身边的世界就会发生细微的改变。影片以精密的叙事结构，探讨时间、选择与遗憾。',
  },
  {
    id: 'voiceless-confession',
    title: '无声告白',
    type: '短片',
    year: 2021,
    role: '听障舞者小满',
    roleType: '主演',
    director: '石井健太',
    runtime: '34分钟',
    rating: 8.0,
    tags: ['文艺', '短片', '舞蹈'],
    cover:
      'https://readdy.ai/api/search-image?query=Cinematic%20short%20film%20poster%20artwork%20in%20deep%20navy%20blue%20and%20charcoal%20with%20warm%20amber%20spotlight%2C%20lonely%20stage%20with%20a%20dancing%20silhouette%2C%20moody%20atmospheric%20minimal%20composition%2C%20professional%20movie%20key%20art%20with%20soft%20grain%20and%20editorial%20style&width=600&height=900&seq=work-18&orientation=portrait',
    summary: '她在无声的世界里，跳出了最响亮的告白。',
    story:
      '听障舞者小满从未听过音乐，却能把每一支曲子的节奏记在身体里。当机会与偏见同时到来，她用一场演出回答了所有质疑。短片围绕肢体与情感展开，安静却有力量。',
  },
];

export const worksFilters = {
  types: ['电影', '电视剧', '短片'],
  roleTypes: ['主演', '配角', '特别出演'],
  years: [2023, 2022, 2021, 2020, 2019, 2018, 2017, 2016, 2015],
};